import {useState, useEffect} from "react";
import {SwalAlertClass} from "core/swalClass";

import axiApi from "ApiCaller";

const CountAssets = {
    has: 0,
    out: 0
}
const CountMeasures = {
    down: 0,
    middle: 0,
    up: 0
}
const CountRoutes = {
    dinamic: 0,
    static: 0
}
const SumaryDataBridge = (props) => {
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar",});
    const [assets, setAssets] = useState(CountAssets);
    const [measures, setMeasures] = useState(CountMeasures);
    const [routes, setRoutes] = useState(CountRoutes);

    useEffect(() => {
        axiApi.get("/api/home/sumary/")
            .then((resp) => {
                if (resp.data.status) {
                    setAssets(resp.data.assets);
                    setMeasures(resp.data.measures);
                    setRoutes(resp.data.routes);
                } else {
                    Alert.error(
                        "Server Error",
                        "Se ha encontrado un error en la carga del mapa."
                    )
                }
            })
            .catch((error) => {
                console.log(error)
                Alert.error(
                    "Server Error",
                    "Se ha encontrado un error en la carga del mapa."
                )
            })
    }, [])
    return (
        <div className="row pt-2">
            <div className="text-center ps-0">
                <div className="text-success border p-2">
                    <h1>{assets.has} / {assets.out}</h1>
                    <small>Puentes con / sin sensor</small>
                </div>
            </div>
        </div>

    );
}

export default SumaryDataBridge;
